
import * as React from 'react';
import { withCurrentItemSet, IDecorateWithCurrentItemSetProps } from '../decorators/selectors';
import { withPageLoadTracker, IDecorateWithPageLoadTrackerProps } from '../decorators/withPageLoadTracker';
import { ItemError, IItemErrorProps } from './ItemError';
import { errorFacet } from '../../facets/DemandFacets';

export type IItemsErrorProps = IDecorateWithCurrentItemSetProps<IDecorateWithPageLoadTrackerProps<IItemErrorProps>>;

export const ItemsError: React.ComponentType<IItemsErrorProps> = withCurrentItemSet()(
    withPageLoadTracker([errorFacet])(ItemError)
);
